/**
 * @generated SignedSource<<13e76051041ad7f664b0e5059de740e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductVideo_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "ProductVideo_item";
};
export type ProductVideo_item$key = {
  readonly " $data"?: ProductVideo_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductVideo_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductVideo_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a23c157d6cc2c5e723de6c5bd1fe6258";

export default node;
